import { Link, LinkProps, useSearchParams } from "react-router-dom";

export default function LinkWithParams({ to, children, onClick, ...props }: LinkProps) {
  const [params] = useSearchParams();
  return (
    <Link
      to={`${to}?${params.toString()}`}
      {...props}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
    >
      {children}
    </Link>
  );
}
